import { Fragment } from 'react';

import Typography from '@components/common/typography';
import { Icon } from '@components/icons';

import CodeBlock from '../_shared/CodeBlock';
import styles from './integrate_panel.module.scss';

interface IProps {
    steps: string[];
    code: string;
    docHref?: string;
}

// A small "here's how you'd build what you just tried" panel: the 3-step flow +
// a copy-able code snippet in a premium dark code block. Makes the sandbox a
// learn-while-you-test tool, not just a demo.
const IntegratePanel = ({ steps, code, docHref }: IProps) => {
    return (
        <div className={styles.panel}>
            <div className={styles.head}>
                <div className={styles.head_left}>
                    <Icon name="task" width={16} height={16} />
                    <Typography variant="body3" weight="semibold">
                        Integrate this in your code
                    </Typography>
                </div>
                {docHref && (
                    <a className={styles.doc_link} href={docHref} target="_blank" rel="noreferrer">
                        View docs
                        <Icon name="external_link" width={12} height={12} />
                    </a>
                )}
            </div>

            <div className={styles.steps}>
                {steps.map((s, i) => (
                    <Fragment key={i}>
                        <div className={styles.step}>
                            <span className={styles.step_num}>{i + 1}</span>
                            <span className={styles.step_label}>{s}</span>
                        </div>
                        {i < steps.length - 1 && <span className={styles.step_arrow}>→</span>}
                    </Fragment>
                ))}
            </div>

            <CodeBlock code={code} language="JavaScript" />
        </div>
    );
};

export default IntegratePanel;
